// 公共配置文件

// 无需用户身份验证的路由
export const ROUTES_WITHOUT_IDENTITY = [
  'error',
  'error2',
  'payResult',
  'aliScan',
  'aliError',
  'aliScanOrderDetail'
];



// WEBPACK FOOTER //
// ./src/config/params.js